<template>
  <v-app>
    <Navbar />
    <v-main class="app-main">
      <div class="main-container">
        <router-view :key="$route.path" />
      </div>
    </v-main>
    <Footer />
    <CarnivalPromoPopup v-model="showCarnivalPromo" />
  </v-app>
</template>

<script>
//import { mapActions } from "vuex";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CarnivalPromoPopup from "@/components/CommunityMapsPopup";
export default {
  name: "App",
  components: {
    Navbar,
    Footer,
    CarnivalPromoPopup
  },
  methods: {
    //...mapActions(["fetchUser"])
  },
  async created() {
    //await this.fetchUser();
  },
  data() {
    return {
      showCarnivalPromo: false
    };
  }
};
</script>
<style>
/* ============================================
   SISTEMA DE DESIGN GLOBAL - LAYOUT
   ============================================ */

.v-application {
  font-family: "Rajdhani", "Orbitron", system-ui, sans-serif !important;

  /* CSS custom properties aproximando a paleta e tokens do Tailwind do projeto de referência */
  --primary: 23 100% 55%;
  --accent: 191 100% 50%;
  --background: 220 12% 5%;
  --foreground: 0 0% 98%;
  --muted: 220 8% 15%;
  --vip: 48 100% 50%;
  --online: 145 100% 50%;
  --offline: 0 0% 45%;
  --warning: 40 100% 55%;

  /* Layout spacing system */
  --container-max-width: 1300px;
  --container-padding-desktop: 32px;
  --container-padding-tablet: 24px;
  --container-padding-mobile: 16px;
  --header-height: 88px;
  --content-spacing-top: 5%;
  --content-spacing-bottom: 64px;
  --content-spacing-horizontal: 32px;

  .title {
    font-family: "Orbitron", system-ui, sans-serif !important;
  }

  .headline {
    font-family: "Orbitron", system-ui, sans-serif !important;
  }

  .v-main {
    padding: 0 !important;
    min-height: calc(100vh - var(--header-height)) !important;
  }
}

.v-application a {
  color: #a3a3a3 !important;
}

.header-divider {
  height: 1px;
  background-color: rgba(255, 255, 255, 0.14);
  margin: 0;
}

/* ============================================
   CONTAINER PRINCIPAL GLOBAL
   ============================================ */

.app-main {
  padding-top: calc(var(--header-height) + 56px);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-container {
  max-width: var(--container-max-width);
  margin: 0 auto;
  padding: var(--content-spacing-top) var(--container-padding-desktop)
    var(--content-spacing-bottom);
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
}

/* ============================================
   SISTEMA RESPONSIVO PROFISSIONAL
   ============================================ */

/* Tablet (768px - 1024px) */
@media (max-width: 1024px) {
  .v-application {
    --header-height: 80px;
    --content-spacing-top: 48px;
    --content-spacing-bottom: 56px;
    --content-spacing-horizontal: 24px;
  }

  .app-main {
    padding-top: calc(var(--header-height) + 44px);
  }

  .main-container {
    padding: var(--content-spacing-top) var(--container-padding-tablet)
      var(--content-spacing-bottom);
  }
}

/* Mobile (até 768px) */
@media (max-width: 768px) {
  .v-application {
    --header-height: 72px;
    --content-spacing-top: 40px;
    --content-spacing-bottom: 48px;
    --content-spacing-horizontal: 20px;
  }

  .app-main {
    padding-top: calc(var(--header-height) + 36px);
  }

  .main-container {
    padding: var(--content-spacing-top) var(--container-padding-mobile)
      var(--content-spacing-bottom);
  }
}

/* Mobile pequeno (até 480px) */
@media (max-width: 480px) {
  .v-application {
    --container-padding-mobile: 12px;
    --content-spacing-top: 32px;
    --content-spacing-bottom: 40px;
    --content-spacing-horizontal: 16px;
  }

  .app-main {
    padding-top: calc(var(--header-height) + 28px);
  }
}

/* ============================================
   CLASSES UTILITÁRIAS PARA PÁGINAS
   ============================================ */

/* Espaçamento do conteúdo principal */
.page-content {
  margin-top: 0;
  flex: 1;
}

/* Espaçamento extra para seções específicas */
.page-section {
  margin-bottom: 48px;
}

@media (max-width: 1024px) {
  .page-section {
    margin-bottom: 36px;
  }
}

@media (max-width: 768px) {
  .page-section {
    margin-bottom: 24px;
  }
}

/* Espaçamento adicional para melhor respiração visual */
.content-breathing {
  padding-top: 24px;
  padding-bottom: 32px;
}

@media (max-width: 1024px) {
  .content-breathing {
    padding-top: 20px;
    padding-bottom: 28px;
  }
}

@media (max-width: 768px) {
  .content-breathing {
    padding-top: 16px;
    padding-bottom: 24px;
  }
}

/* Classe utilitária para espaçamento extra do topo quando necessário */
.page-top-spacing {
  margin-top: 24px;
}

@media (max-width: 1024px) {
  .page-top-spacing {
    margin-top: 20px;
  }
}

@media (max-width: 768px) {
  .page-top-spacing {
    margin-top: 16px;
  }
}

/* ============================================
   OTIMIZAÇÕES DE PERFORMANCE E ACESSIBILIDADE
   ============================================ */

/* Smooth scroll para toda a aplicação */
html {
  scroll-behavior: smooth;
}

/* Otimização para animações em dispositivos que preferem menos movimento */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* Foco visível para acessibilidade */
*:focus-visible {
  outline: 2px solid hsla(var(--primary));
  outline-offset: 2px;
}
</style>
